import AuthLogin from './views/Auth/Login';
import AuthLoginMaster from './views/Auth/LoginMaster';

import AuthResetPass from './views/Auth/ResetPass';
import AuthAlterarSenha from './views/Auth/AlterarSenha';
import AccessToken from './views/Auth/AcessoToken';
import ClientDashboard from './views/Client/Dashboard';
import ClientMaquinaVirtual from './views/Client/MaquinaVirtual';
import ClientNovoLink from './views/Client/NovoLink';
import ClientTransacoes from './views/Client/Transacoes';
import ClientSuporte from './views/Client/Suporte';
import ClientFAQ from './views/Client/FAQ';
import ClientFAQMaquinaVirtual from './views/Client/FAQ/MaquinaVirtual';
import ClientAlterarSenha from './views/Client/AlterarSenha';
import ClientExtrato from './views/Client/Extrato';
import Perfil from './views/Client/Perfil';
import PerfilEdit from './views/Client/PerfilEdit';
import ClientSimulador from './views/Client/Simulador';
import HistoricoNotificoes from './views/Client/HistoricoNotificacoes';
import ClientDetalhesLink from './views/Client/DetalhesLink';
import Dirf from './views/Client/Dirf';

const routes = [
	{
		path: '/login',
		name: 'Login',
		mini: 'UV',
		component: AuthLogin,
		layout: '/auth',
		redirect: true,
		groups: 'All',
		permission: [],
	},
	{
		path: '/master/login',
		name: 'Login',
		mini: 'UV',
		component: AuthLoginMaster,
		layout: '/auth',
		redirect: true,
		groups: 'All',
		permission: [],
	},
	{
		path: '/reset-pass',
		name: 'Reset Pass',
		mini: 'UV',
		component: AuthResetPass,
		layout: '/auth',
		redirect: true,
		groups: 'All',
		permission: [],
	},{
		path: '/token-authentication',
		name: 'Acesso via token',
		mini: 'UV',
		component: AccessToken,
		layout: '/auth',
		redirect: true,
		groups: 'All',
		permission: [],
	},
	{
		path: '/alterar-senha/:token',
		name: 'Alterar Senha',
		mini: 'UV',
		component: AuthAlterarSenha,
		layout: '/auth',
		redirect: true,
		groups: 'All',
		permission: [],
	},
	{
		path: '/dashboard',
		name: 'Dashboard',
		mini: 'NP',
		component: ClientDashboard,
		layout: '/client',
		redirect: true,
		groups: 'All',
		permission: [],
	},
	{
		path: '/maquina-virtual',
		name: 'Maquina Virtual',
		mini: 'NP',
		component: ClientMaquinaVirtual,
		layout: '/client',
		redirect: true,
		groups: 'All',
		permission: [],
	},
	{
		path: '/novo-link',
		name: 'Novo link',
		mini: 'NP',
		component: ClientNovoLink,
		layout: '/client',
		redirect: true,
		groups: 'All',
		permission: [],
	},
	{
		path: '/transacoes',
		name: 'Transacoes',
		mini: 'NP',
		component: ClientTransacoes,
		layout: '/client',
		redirect: true,
		groups: 'All',
		permission: [],
	},
	{
		path: '/suporte',
		name: 'Suporte',
		mini: 'NP',
		component: ClientSuporte,
		layout: '/client',
		redirect: true,
		groups: 'All',
		permission: [],
	},
	{
		path: '/simulador',
		name: 'Simulador',
		mini: 'NP',
		component: ClientSimulador,
		layout: '/client',
		redirect: true,
		groups: 'All',
		permission: [],
	},
	{
		path: '/faq',
		name: 'Perguntas Frequentes',
		mini: 'NP',
		component: ClientFAQ,
		layout: '/client',
		redirect: true,
		groups: 'All',
		permission: [],
	},
	{
		path: '/alterar-senha',
		name: 'Alterar senha',
		mini: 'NP',
		component: ClientAlterarSenha,
		layout: '/client',
		redirect: true,
		groups: 'All',
		permission: [],
	},
	{
		path: '/perfil',
		name: 'Perfil',
		mini: 'NP',
		component: Perfil,
		layout: '/client',
		redirect: true,
		groups: 'All',
		permission: [],
	},
	{
		path: '/perfil-edit',
		name: 'Editar perfil',
		mini: 'NP',
		component: PerfilEdit,
		layout: '/client',
		redirect: true,
		groups: 'All',
		permission: [],
	},
	{
		path: '/faq/maquina-virtual',
		name: 'Maquina Virtual',
		mini: 'NP',
		component: ClientFAQMaquinaVirtual,
		layout: '/client',
		redirect: true,
		groups: 'All',
		permission: [],
	},
	{
		path: '/detalhes-link',
		name: 'Detalhes do Link',
		mini: 'NP',
		component: ClientDetalhesLink,
		layout: '/client',
		redirect: true,
		groups: 'All',
		permission: [],
	},
	{
		path: '/extrato',
		name: 'Extrato',
		mini: 'NP',
		component: ClientExtrato,
		layout: '/client',
		redirect: true,
		groups: 'All',
		permission: [],
	},
	{
		path: '/dirf',
		name: 'Dirf',
		mini: 'NP',
		component: Dirf,
		layout: '/client',
		redirect: true,
		groups: 'All',
		permission: [],
	},
	{
		path: '/notificacoes',
		name: 'Notificações',
		mini: 'NP',
		component: HistoricoNotificoes,
		layout: '/client',
		redirect: true,
		groups: 'All',
		permission: [],
	},
];

export default routes;
